
      // Check if the query parameter 'feedback=1' is present
      const urlParams = new URLSearchParams(window.location.search);
      const isFeedbackEnabled = urlParams.get('feedback') === '1';
      const isFeedbucketEnabled = urlParams.get('feedbucket') === '1';
      const appEnv = import.meta.env.VITE_APP_ENV;
      const isProduction = appEnv === 'production';
      console.log('APP ENV:', import.meta.env.VITE_APP_ENV);
      if (
        !isProduction &&
        (isFeedbackEnabled || isFeedbucketEnabled) &&
        window.location.hostname !== 'localhost' &&
        window.location.hostname !== '127.0.0.1'
      ) {
        (function (k, s) {
          s = document.createElement('script');
          s.module = true;
          s.async = true;
          s.src = 'https://cdn.feedbucket.app/assets/feedbucket.js';
          s.dataset.feedbucket = k;
          document.head.appendChild(s);
        })('hG30LMhsd0T7fzQlWoHo');
      }
    